import React from "react";
import { Layers, Hash, FileText, CheckCircle2 } from "lucide-react";
import { FormInput, FormSelect, FormTextarea } from "./SharedFormComponents";

export const SubCategoryForm = ({ form, errors, handleInputChange, dropdowns }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <FormInput
        icon={<Layers size={14} />}
        label="Sub Category Name"
        required
        field="subCategoryName"
        value={form.subCategoryName}
        onChange={handleInputChange}
        error={errors.subCategoryName}
        placeholder="e.g. Hinges, Runner Systems"
      />
      <FormInput
        icon={<Hash size={14} />}
        label="Sub Category Code"
        field="subCategoryCode"
        value={form.subCategoryCode}
        onChange={handleInputChange}
        error={errors.subCategoryCode}
        placeholder="e.g. SUB-001"
      />
      <div className="md:col-span-2">
        <FormSelect
          icon={<Layers size={14} />}
          label="Category"
          required
          field="category"
          options={[
            { value: "", label: "Select Category" },
            ...(dropdowns?.categories?.map((c) => ({
              value: c._id,
              label: c.label,
            })) || []),
          ]}
          value={form.category || ""}
          onChange={handleInputChange}
          error={errors.category}
        />
      </div>
      <div className="md:col-span-2">
        <FormTextarea
          icon={<FileText size={14} />}
          label="Description"
          field="description"
          value={form.description}
          onChange={handleInputChange}
          error={errors.description}
          placeholder="Sub Category details..."
        />
      </div>
      <div className="md:col-span-2">
        <FormSelect
          icon={<CheckCircle2 size={14} />}
          label="Status"
          required
          field="status"
          options={[
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ]}
          value={form.status || "ACTIVE"}
          onChange={handleInputChange}
          error={errors.status}
        />
      </div>
    </div>
  );
};
